
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';



export const handleExport = (data) => {
    // Mapeia os dados para "achatar" o objeto prod
    const flattenedData = data.map(item => {
        const { prod, slug, ...rest } = item;
        const  { id,  imageUrl, ...prodRest } = prod || {};
        return {
            ...rest,
            ...prodRest,
        };
    });

    const worksheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Relatorio');

    const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
    });

    const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, 'relatorio_vendedores.xlsx');
};